import { OnInit, OnChanges } from "@angular/core/src/metadata/lifecycle_hooks";
import { Component, Input, ElementRef } from "@angular/core";
import {
    TravelService,
    SeatAllocation,
    SeatStatus
} from "../../services/travel.service";
import {
    StopItem,
    ReferenceDataService
} from "../../services/reference-data.service";
import * as moment from "moment";

@Component({
    selector: "gaweb-info",
    templateUrl: `./info.component.html`
})
export class InfoComponent implements OnInit {
    @Input()
    title: string;
    @Input()
    collapsed = true;

    constructor(
        private travelService: TravelService,
        private referenceDataService: ReferenceDataService,
        private componentElement: ElementRef
    ) {}
    ngOnInit(): void {
        this.collapsed = !this.collapsed;
        this.collapsed = !this.collapsed;
    }

    private updateCss() {
        $(this.componentElement.nativeElement).removeClass("collapsed");
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/info/info.component.ts